import { Socket } from 'socket.io-client';

import { environment } from '@env/environment';

const OBJECT_ID = /^[0-9a-fA-F]{24}$/;

export const sanitizeNotificationEntityIds = (entityIds: Array<string | null | undefined> = []): string[] => {
    return [...new Set(entityIds.filter((id): id is string => !!id && OBJECT_ID.test(id)))];
};

export const getNotificationSocketConnection = (token: string, entityIds: Array<string | null | undefined> = []) => {
    if (!token) {
        return null;
    }

    const ids = sanitizeNotificationEntityIds(entityIds);
    const baseUrl = new URL((environment as any).notification?.url || environment.authentication.url).origin;
    const path = (environment as any).notification?.path
        ? (environment as any).notification.path + 'socket.io'
        : undefined;

    return {
        url: baseUrl,
        options: {
            path,
            withCredentials: true,
            auth: {
                token,
                entityIds: ids
            },
            extraHeaders: {
                Authorization: `Bearer ${token}`
            }
        }
    };
};

export const emitSubscribeEntities = (socket: Socket | null | undefined, entityIds: Array<string | null | undefined>): void => {
    const ids = sanitizeNotificationEntityIds(entityIds);
    if (!socket || !ids.length) {
        return;
    }

    if (socket.connected) {
        socket.emit('subscribe-entities', ids);
        return;
    }

    socket.once('connect', () => {
        socket.emit('subscribe-entities', ids);
    });
};
